import { Avatar } from 'antd'
import { ProviderAuthenticationClient } from '~/plugins/data-connector/authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderXeroCommon } from '../common'

export const ProviderXeroClient: ProviderClient = {
  key: ProviderXeroCommon.key,
  authentication: ProviderAuthenticationClient.Oauth2(
    ProviderXeroCommon.authentication,
  ),
  description: {
    label: 'Xero',
    icon: (
      <Avatar
        size="small"
        src="https://cledara-public.s3.eu-west-2.amazonaws.com/Xero.png"
      />
    ),
    triggers: [],
    actions: [
      {
        key: 'createManyDraftInvoices',
        label: 'Create draft invoices',
        input: [
          {
            key: 'tenantId',
            type: 'string',
          },
          {
            key: 'invoices',
            type: 'object',
          },
        ],
        output: [],
      },
      {
        key: 'findOrCreateContact',
        label: 'Find or create contact',
        input: [
          {
            key: 'tenantId',
            type: 'string',
          },
          {
            key: 'contact',
            type: 'object',
          },
        ],
        output: [],
      },
      {
        key: 'getUserOrganizations',
        label: 'Get user organizations',
        input: [],
        output: [{ key: 'organizations', type: 'object' }],
      },
    ],
  },
}
